import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=4a4f3c91"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports